export default __webpack_public_path__ + "static/media/eye.3b44bf80.svg";